import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
export const StyledRoot = styled.ul.withConfig({ displayName: "auir-611444a-StyledRoot", componentId: "auir-611444a-14083b8" }) `
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;

  & > li {
    display: inline-block;
  }

  ${injectSpacing('margin')}
`;
export const StyledSegment = styled.button.withConfig({ displayName: "auir-611444a-StyledSegment", componentId: "auir-611444a-xpl0dl" }) `
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;

  cursor: pointer;

  background: none;
  border: none;
  width: 40px;
  height: 40px;
  padding: var(${(props) => props.theme.responsive.spacing.xxs});

  &::after {
    content: '';
    width: 100%;
    height: 2px;
    margin-top: 2px;
    opacity: 0.6;
    background-color: var(
      ${(props) => props.theme.colors.interaction.secondary.default}
    );
    transform: scaleY(1);
    transform-origin: bottom;

    transition: 150ms var(${(props) => props.theme.easing});
    transition-property: transform, background-color, opacity;
  }

  &[aria-selected='true'] {
    &::after {
      opacity: 1;
      background-color: var(
        ${(props) => props.theme.colors.interaction.secondary.active}
      );
      transform: scaleY(2);
    }
  }

  &:focus,
  &:hover {
    &::after {
      opacity: 1;
      background-color: var(
        ${(props) => props.theme.colors.interaction.secondary.active}
      );
    }
  }
`;
//# sourceMappingURL=Indicator.styles.mjs.mjs.map